import MinorLogo from "../ui/MinorLogo";
import React from "react";
import styled from "styled-components";

const MinorLogoContainer: React.FC = () => {
    const sectionLogos = [
        {
            label: "Enti",
            logos: [
                { path: "mediterranea.png", title: "Mediterranea Associazione per lo Sviluppo Locale" },
                { path: "amici_della_biblioteca.jpg" },
                { path: "cittadella_mediterranea_scienza.png" },
                { path: "logo_arci.png" },
                { path: "springo-creative-studio-01-2.png" },
                { path: "UNIVERSITA.png" }
            ]
        },
        {
            label: "Scuole",
            logos: [
                { path: "comprensivo_alliste.png" },
                { path: "Comprensivo_MaglieLogo_Stampa.jpg" },
                { path: "comprensivo_melissano.png" },
                { path: "logo_bachelet.png" },
                { path: "logo_deviti_demarco.png" },
                { path: "logo_galilei.png" },
                { path: "logo_ipseo_aldo_moro.jpg" },
                { path: "logo_mattei.png" },
                { path: "logo_medi.png" },
                { path: "logo_salvemini.png" }
            ]
        },
        {
            label: "Comuni e Ambiti",
            logos: [
                { path: "comune_alessano.png" },
                { path: "comune_copertino.png" },
                { path: "comune_melissano.png" },
                { path: "comune_ugento.png" },
                { path: "logo_casarano.jpg" },
                { path: "logo_lecce.jpg" }
            ]
        }
    ];
    return (
        <Container>
            {sectionLogos.map(({ label, logos }) => (
                <section key={label}>
                    <h4>{label}</h4>
                    <LogosWrapper>
                        {logos.map((logo: { path: string; padding?: number; title?: string }) => {
                            return <MinorLogo key={logo.path} logo={logo.path} padding={logo.padding} title={logo.title} />;
                        })}
                    </LogosWrapper>
                </section>
            ))}
        </Container>
    );
};

export default MinorLogoContainer;

const Container = styled.div`
    text-align: center;
    overflow: hidden;
    padding-top: 2rem;
    width: 100%;
    display: flex;
    padding: 0 1rem 1rem 1rem;
    h4 {
        padding: 0 1rem;
        color: ${props => props.theme.colors.white(1)};
    }
    section {
        max-width: 80rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 1rem;
    }
`;

const LogosWrapper = styled.div`
    padding: 0 1rem;
    flex: 1;
    padding: 2rem 0;
    box-shadow: 0px 3px 1px -2px ${props => props.theme.colors.black(0.2)}, 0px 2px 2px 0px ${props => props.theme.colors.black(0.14)},
        0px 1px 5px 0px ${props => props.theme.colors.black(0.12)};
    background-color: ${props => props.theme.colors.white(1)};
    border-radius: 0.3rem;
`;
